'use client';

import { useQuery } from '@tanstack/react-query';
import { useAuthStore } from '@/stores/auth-store';
import { getHrmDashboardConfig } from '@/services/dashboard.service';
import type { HrmDashboardConfig } from '@/types/hrm-dashboard-config';

export function useDashboardConfig() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);

  const query = useQuery({
    queryKey: ['hrm-dashboard', 'config'],
    queryFn: getHrmDashboardConfig,
    enabled: isAuthenticated,
    staleTime: 5 * 60_000,
    retry: 1,
  });

  return {
    config: query.data ?? null,
    isLoading: query.isLoading,
    error: query.error,
    refetch: query.refetch,
  };
}

export function useDashboardWidgetIds(config: HrmDashboardConfig | null): Set<string> {
  if (!config?.widgets?.length) {
    return new Set([
      'welcome',
      'attendance-today',
      'leave-balance',
      'next-holiday',
      'headcount',
    ]);
  }
  return new Set(config.widgets.map((w) => w.id));
}

export function hasDashboardWidget(widgetIds: Set<string>, id: string): boolean {
  return widgetIds.has(id);
}
